import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./Home/Home.css";

import loading from "../../images/24.gif";
import PropTypes from "prop-types";

import ReactTooltip from "react-tooltip";
import Navigations from "../../config/navbar";
import firebase from "./../../config/firebase";

import Footer from "../../components/footer";
import FirstSection from "../../components/firstSection";
import SecondSection from "../../components/secondSection";
import ThirdSection from "../../components/thirdSection";
import CaroselSection from "../../components/caroselSection";
import PortfolioSection from "../../components/portfolioSection";
import MessengerData from "../../components/messangerPlugin";
import Fade from "react-reveal/Fade";
import LoaderScreen from "../../components/Loader/loader";
import "./Projects/projects.css";
class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      backdrop: "static",
      id: null,
      fileName: null,
      body: null,
      buttonLink: null,
      githubLink: null,
      imagePage: null,
      selectedPostIndex: "",
      arr: [],
      responsive: {
        0: {
          items: 1,
        },
        450: {
          items: 2,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 5,
        },
      },
    };

    this.myRefProject = React.createRef();
    this.myRefServices = React.createRef();
    this.myRefContact = React.createRef();
    this.myRefHome = React.createRef();
    this.myRefAbout = React.createRef();
    this.myRefClients = React.createRef();
  }

  handleOnHome = (event) => {
    //.current is verification that your element has rendered
    window.scrollTo(0, this.myRefHome.current.offsetTop);
  };
  handleOnClients = (event) => {
    //.current is verification that your element has rendered
    window.scrollTo(0, this.myRefClients.current.offsetTop);
  };
  handleOnServices = (event) => {
    //.current is verification that your element has rendered
    window.scrollTo(0, this.myRefServices.current.offsetTop);
  };
  handleOnProject = (event) => {
    //.current is verification that your element has rendered
    window.scrollTo(0, this.myRefProject.current.offsetTop);
  };
  handleOnAbout = (event) => {
    //.current is verification that your element has rendered
    window.scrollTo(0, this.myRefAbout.current.offsetTop);
  };
  handleOnContact = (event) => {
    //.current is verification that your element has rendered
    window.scrollTo(0, this.myRefContact.current.offsetTop);
  };

  toggle = (id, fileName, body, buttonLink, githubLink, imagePage) => {
    this.setState({
      modal: !this.state.modal,
      id: id,
      fileName: fileName,
      body: body,
      buttonLink: buttonLink,
      githubLink: githubLink,
      imagePage: imagePage,
    });
    // console.log(id)
    // console.log(fileName)
    // console.log(body)
    // console.log(buttonLink)
    // console.log(githubLink)
  };

  componentDidMount() {
    this.setState({ pageloader: true });
    firebase
      .database()
      .ref("Projects")
      .limitToLast(3)
      .on("value", (snapshot) => {
        let message = snapshot.val();
        var newArr = [];
        for (let word in message) {
          newArr.push({
            createAt: message[word].createAt,
            category: message[word].category,
            newPostKey: message[word].newPostKey,
            headingName: message[word].headingName,
            body: message[word].body,
            githubLink: message[word].githubLink,
            buttonLink: message[word].buttonLink,
            downloadURL: message[word].downloadURL,
          });
        }
        // console.log(message);
        // // arr.push(message)
        this.setState({ arr: newArr, pageloader: false });
      });
  }

  render() {
    const { arr, pageloader } = this.state;

    // const html = body;

    return (
      <div ref={this.myRefHome}>
        <Navigations
          handleClick={this.handleOnHome}
          handleClick1={this.handleOnProject}
          handleClick2={this.handleOnAbout}
          handleClick3={this.handleOnContact}
          handleOnServices={this.handleOnServices}
          handleOnClient={this.handleOnClients}
        />
        {pageloader === true ? (
          <LoaderScreen />
        ) : (
          <Fade>
            <div>
              <br id="home" />
              <ReactTooltip place="top" type="dark" effect="float" />
              <FirstSection />
              <div
                style={{ marginBottom: "5rem" }}
                ref={this.myRefServices}
              ></div>
              <SecondSection />
              <CaroselSection />
              <div
                style={{ marginBottom: "5rem" }}
                ref={this.myRefClients}
              ></div>
              <PortfolioSection />
              <div
                style={{ marginBottom: "5rem" }}
                ref={this.myRefProject}
              ></div>
              <div className="container-fluid">
                <div className="mt-5">
                  <h1
                    className="text-center"
                    style={{ color: "rgb(118, 102, 223)", fontSize: 50 }}
                  >
                    <i class="fas fa-pencil-ruler"></i> My Recent Work
                  </h1>

                  <h5 className="text-center">
                    Here are a few recent design projects
                  </h5>

                  <a href={`/allprojects`} style={{ textDecoration: "none" }}>
                    <h5
                      className="text-center mt-3"
                      style={{ color: "rgb(118, 102, 223)" }}
                    >
                      View More Projects{" "}
                      <i
                        style={{ color: "rgb(118, 102, 223)" }}
                        class="fas fa-external-link-square-alt"
                      ></i>
                    </h5>
                  </a>

                  {!arr.length ? (
                    <div
                      style={{
                        position: "absolute",
                        left: "50%",
                        marginTop: "10%",

                        // top: "50%",
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <img alt="loading" src={loading} />
                    </div>
                  ) : (
                    <div className="row mt-3">
                      <section id="portfolio" class="portfolio">
                        <div class="">
                          <div
                            class="row portfolio-container"
                            data-aos="fade-up"
                            data-aos-delay="200"
                          >
                            {this.state.arr.map((e, i) => {
                              return (
                                <div class="col-md-4 col-xs-12">
                                  <div class="portfolio-item filter-web">
                                    <div class="portfolio-wrap">
                                      <img
                                        src={e.downloadURL}
                                        class="img-fluid"
                                        style={{
                                          height: "15rem",
                                          width: "100%",
                                        }}
                                        alt=""
                                      />
                                      <div class="portfolio-info">
                                        <h4>{e.headingName}</h4>
                                        <p>
                                          {e.category === "web-apps"
                                            ? "WEB APP"
                                            : e.category === "mobile-app"
                                            ? "Mobile App"
                                            : ""}
                                        </p>
                                        <div class="portfolio-links">
                                          <i class="bx bx-plus"></i>

                                          <a
                                            href={`/projectDetail/${e.newPostKey}`}
                                            title="More Details"
                                          >
                                            <i class="fas fa-link"></i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </section>
                    </div>
                  )}

                  {/* <button
              style={{
                backgroundColor: "rgb(118, 102, 223)",
                color: "white",
                // marginLeft: 10,
              }}
              type="button"
              class="btn btn-block col-md-12"
              onClick={() => this.props.history.push("allprojects")}
            >
              View More Projects
            </button> */}
                </div>
              </div>
              <ThirdSection />
              <div>
                <Footer />
              </div>
            </div>
          </Fade>
        )}
        <MessengerData />
      </div>
    );
  }
}

Home.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(Home);

// <div className="row mt-5">
// {this.state.arr.map((e, i) => {
//   return (
//     <div class="col-sm-12 col-md-6 " key={i}>
//       {/* <h2 class="sector">Education - Permanent</h2> */}
//       <div class="box20 " style={{ marginBottom: 30 }}>
//         <img
//           alt="downloadURL"
//           src={e.downloadURL}
//           style={{ height: 300 }}
//         />
//         <div class="box-content">
//           {/* <i class="fas fa-university circle-icon"></i> */}
//           <span style={{ display: "none" }}>{e.category}</span>
//           <h3 class="title">{e.headingName}</h3>
//           <br />
//           <button
//             type="button"
//             class="btn btn-outline-dark"
//             // onClick={() =>
//             //   this.toggle(
//             //     e.newPostKey,
//             //     e.headingName,
//             //     e.body,
//             //     e.buttonLink,
//             //     e.githubLink,
//             //     e.downloadURL
//             //   )
//             // }
//             // data-toggle="modal"
//             // data-target="#exampleModalScrollable"
//             // data-tip="link"
//             // data-place="right"
//           >
//             <Link
//               to={`/projectDetail/${e.newPostKey}`}
//               // class="smallLinkButton"
//               style={{
//                 color: "black",
//                 marginRight: 5,
//                 textDecoration: "none",
//               }}
//             >
//               {" "}
//               Learn More
//             </Link>
//           </button>
//           {/* <a className='asd' style={{ color: 'white' }} ><Icon size={32} icon={locationArrow} /></a> */}
//         </div>
//       </div>

//       <div
//         class="modal fade"
//         id="exampleModalScrollable"
//         data-backdrop="static"
//         tabindex="-1"
//         role="dialog"
//         aria-labelledby="exampleModalScrollableTitle"
//         aria-hidden="true"
//       >
//         {/* aria-labelledby="staticBackdropLabel"  */}
//         <div
//           class="modal-dialog modal-dialog-scrollable"
//           role="document"
//         >
//           <div class="modal-content">
//             <div class="modal-header">
//               <h5
//                 class="modal-title"
//                 id="exampleModalScrollableTitle"
//               >
//                 {fileName}
//               </h5>
//               <button
//                 type="button"
//                 class="close"
//                 data-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">&times;</span>
//               </button>
//             </div>

//             <div class="modal-body">
//               <img
//                 alt="Responsiveimage"
//                 class="img-thumbnail"
//                 src={imagePage}
//               />

//               <p>Description: {ReactHtmlParser(html)}</p>
//               <a
//                 href={buttonLink}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 type="button"
//                 class="btn btn-outline-primary btn-block"
//               >
//                 View
//               </a>
//               <br />
//             </div>
//             <div
//               class="modal-footer"
//               style={{
//                 display: "flex",
//                 justifyContent: "space-between",
//               }}
//             >
//               <a
//                 href={githubLink}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <img
//                   alt="githublogo"
//                   style={{
//                     justifyContent: "flex-start",
//                     cursor: "pointer",
//                     height: 40,
//                   }}
//                   src={githubLogo}
//                 />
//               </a>

//               {/* <Button style={{ justifyContent: 'flex-start' }} href='{link}' target="_blank" color="primary" outline >Download</Button> */}
//               <button
//                 style={{ justifyContent: "flex-end" }}
//                 type="button"
//                 class="btn btn-outline-dark"
//                 data-dismiss="modal"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// })}
// </div>
